import React, { useState } from 'react';

import { getShouldDisableSkipMfa } from '@/features/featureFlags/selectors';
import { addDevice, setSkipped } from '@/features/login/slice';
import ZeroState from '@/features/mfa/components/MfaDevices/ZeroState';

import {
  Argentina,
  Australia,
  Brazil,
  Canada,
  France,
  Germany,
  Ireland,
  Mexico,
  Netherlands,
  Singapore,
  UnitedKingdom,
  UnitedStates
} from '@bypasslane/clover--icons-sprout-flags';
import { useDispatch, useSelector } from 'react-redux';

export const AddDeviceContainer = () => {
  const dispatch = useDispatch();

  const isDevicesLoading = useSelector((state) => state.auth.isDevicesLoading);

  const [phone, setPhone] = useState('');
  const [e164Number, setE164Number] = useState('');
  const [error, setError] = useState();

  const handleSave = () => {
    if (!phone) {
      setError('Phone number is required');
      return;
    }
    if (!e164Number) {
      setError('Invalid phone number');
      return;
    }

    const device = {
      deviceType: 'SMS',
      deviceIdentifier: e164Number
    };
    dispatch(addDevice(device));
  };

  const disableSkipButton = useSelector(getShouldDisableSkipMfa);

  const handleSkip = () => {
    dispatch(setSkipped(true));
  };

  const handleNumberChange = (e) => {
    setPhone(e.target.value);
    if (e.target.value) {
      setError(undefined); // Clear the error when phone number starts to have a value
    }
  };

  const handleE164 = (e164) => {
    setE164Number(e164);
  };

  const handleValidation = (valid) => {
    setError(valid ? undefined : 'Invalid phone number');
  };

  const handleCountryChange = (selectedCountry) => {
    setCountry(selectedCountry);
  };

  const countryCodeListOptions = [
    { icon: <UnitedStates size={24} />, label: 'US +1', value: 'US' },
    { icon: <Argentina size={24} />, label: 'AR +54', value: 'AR' },
    { icon: <Australia size={24} />, label: 'AU +61', value: 'AU' },
    { icon: <Brazil size={24} />, label: 'BR +55', value: 'BR' },
    { icon: <Canada size={24} />, label: 'CA +1', value: 'CA' },
    { icon: <France size={24} />, label: 'FR +33', value: 'FR' },
    { icon: <Germany size={24} />, label: 'DE +49', value: 'DE' },
    { icon: <Ireland size={24} />, label: 'IE +353', value: 'IE' },
    { icon: <Mexico size={24} />, label: 'MX +52', value: 'MX' },
    { icon: <Netherlands size={24} />, label: 'NL +31', value: 'NL' },
    { icon: <UnitedKingdom size={24} />, label: 'GB +44', value: 'GB' },
    { icon: <Singapore size={24} />, label: 'SG +65', value: 'SG' }
  ];

  const [country, setCountry] = useState(countryCodeListOptions[0]); // Default to the first country

  return (
    <ZeroState
      handleSave={handleSave}
      handleSkip={handleSkip}
      error={error}
      phone={phone}
      handleNumberChange={handleNumberChange}
      handleE164={handleE164}
      handleValidation={handleValidation}
      country={country}
      handleCountryChange={handleCountryChange}
      countryCodeListOptions={countryCodeListOptions}
      loading={isDevicesLoading}
      disableSkipButton={disableSkipButton}
    />
  );
};

export default AddDeviceContainer;
AddDeviceContainer.displayName = 'AddDeviceContainer';
